exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-8a3f5ea0]{margin-top:15px;font-size:5em}.info[data-v-8a3f5ea0]{font-weight:300;color:#9aabb1;margin:0}.button[data-v-8a3f5ea0]{margin-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a3f5ea0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/layouts/error.vue
// module id = S0TO
// module chunks = 3